var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTsCalculatorMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.5,10c-3.084,0-5.5,1.318-5.5,3v8c0,1.682,2.416,3,5.5,3s5.5-1.318,5.5-3v-8c0-1.682-2.416-3-5.5-3Zm0,13c-2.652,0-4.5-1.054-4.5-2v-2.254c.987.764,2.62,1.254,4.5,1.254s3.513-.49,4.5-1.254v2.254c0,.946-1.848,2-4.5,2Zm0-4c-2.652,0-4.5-1.054-4.5-2v-2.254c.987.764,2.62,1.254,4.5,1.254s3.513-.49,4.5-1.254v2.254c0,.946-1.848,2-4.5,2Zm0-4c-2.652,0-4.5-1.054-4.5-2s1.848-2,4.5-2,4.5,1.054,4.5,2-1.848,2-4.5,2Zm14.5-11h-12v5h12v-5Zm-1,4h-10v-3h10v3Zm1,5h-1v-2h1v2Zm-3,0h-1v-2h1v2Zm-3,0h-1v-2h1v2Zm-1,2h1v2h-1v-2Zm3,0h1v2h-1v-2Zm4,2h-1v-2h1v2Zm-7,2h7v1h-7v-1ZM24,2.5v21.5h-12.387c.329-.307.611-.639.828-1h10.559V2.5c0-.827-.673-1.5-1.5-1.5H6.5c-.827,0-1.5.673-1.5,1.5v5.515c-.341.013-.676.035-1,.074V2.5c0-1.378,1.121-2.5,2.5-2.5h15c1.379,0,2.5,1.122,2.5,2.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTsCalculatorMoney);
export default __webpack_public_path__ + "static/media/fi-ts-calculator-money.fc4248ecc8186cfd7d1e0feb2b3fbcfe.svg";
export { ForwardRef as ReactComponent };